module.exports = __webpack_public_path__ + "static/media/autMenoresDesafio.6141f23a.pdf";